'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _unitaudit = require('./unitaudit.html');

var _unitaudit2 = _interopRequireDefault(_unitaudit);

var _unitaudit3 = require('./unitaudit.controller');

var _unitaudit4 = _interopRequireDefault(_unitaudit3);

require('./unitaudit.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var unitauditComponent = {
  restrict: 'E',
  bindings: {},
  template: _unitaudit2.default,
  controller: _unitaudit4.default,
  controllerAs: 'vm'
};

exports.default = unitauditComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/unitaudit/unitaudit.component.js